//#region redux
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { shareRegisterSnoozed } from "store/actions/shareRegisterActions";
//#endregion
import { useSnoozeAction } from "components/common";

function useShareRegisterSnoozeAction(id: number, markAsDone: (id: number) => void) {
  const dispatch = useDispatch();

  const onSnoozeSuccess = () => {
    dispatch(shareRegisterSnoozed(id));
    markAsDone(id);
  };
  const { snoozeAction } = useSnoozeAction(id, WintSuperkollAPIModel.TodoType.ShareRegister, onSnoozeSuccess);

  return snoozeAction;
}

export default useShareRegisterSnoozeAction;
